import React from "react";
import { useTranslation } from "react-i18next";

import { ButtonsBlock } from "./styles";
import { Button } from "@mui/material";

export const ButtonsActions = (props) => {
  const { t } = useTranslation();
  const disabled = props.disabled;
  const buttonActions = props.buttonActions;
  return (
    <>
      <ButtonsBlock>
        <Button
          onClick={() => buttonActions("acceptedAll")}
          disabled={disabled}
          variant={"contained"}
          color={"success"}
        >
          {t(`buttons.accept_all`)}
        </Button>
        <Button
          onClick={() => buttonActions("rejectedAll")}
          disabled={disabled}
          variant={"contained"}
          color={"warning"}
        >
          {t(`buttons.reject_all`)}
        </Button>
      </ButtonsBlock>
    </>
  );
};
